/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationStage } from './ApplicationStage'
import {
  ApplicationStageFromJSON,
  ApplicationStageFromJSONTyped,
  ApplicationStageToJSON,
} from './ApplicationStage'

/**
 *
 * @export
 * @interface GetPaymentStatus200ResponseData
 */
export interface GetPaymentStatus200ResponseData {
  /**
   * Последний ордер оплачен (или неоплаченных ордеров нет)
   * @type {boolean}
   * @memberof GetPaymentStatus200ResponseData
   */
  isOrderPayed: boolean
  /**
   * Следующая стадия заявки (при оплате — APPLICATION_STAGE_7)
   * @type {ApplicationStage}
   * @memberof GetPaymentStatus200ResponseData
   */
  nextStage: ApplicationStage
  /**
   * Название выбранной услуги из неоплаченного ордера; null, если ордера нет
   * @type {string}
   * @memberof GetPaymentStatus200ResponseData
   */
  selectedProduct: string | null
  /**
   * Ссылка на оферту
   * @type {string}
   * @memberof GetPaymentStatus200ResponseData
   */
  offerDocumentUrl: string
}

/**
 * Check if a given object implements the GetPaymentStatus200ResponseData interface.
 */
export function instanceOfGetPaymentStatus200ResponseData(
  value: object
): value is GetPaymentStatus200ResponseData {
  if (!('isOrderPayed' in value) || value['isOrderPayed'] === undefined)
    return false
  if (!('nextStage' in value) || value['nextStage'] === undefined) return false
  if (!('selectedProduct' in value) || value['selectedProduct'] === undefined)
    return false
  if (!('offerDocumentUrl' in value) || value['offerDocumentUrl'] === undefined)
    return false
  return true
}

export function GetPaymentStatus200ResponseDataFromJSON(
  json: any
): GetPaymentStatus200ResponseData {
  return GetPaymentStatus200ResponseDataFromJSONTyped(json, false)
}

export function GetPaymentStatus200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPaymentStatus200ResponseData {
  if (json == null) {
    return json
  }
  return {
    isOrderPayed: json['isOrderPayed'],
    nextStage: ApplicationStageFromJSON(json['nextStage']),
    selectedProduct: json['selectedProduct'],
    offerDocumentUrl: json['offerDocumentUrl'],
  }
}

export function GetPaymentStatus200ResponseDataToJSON(
  value?: GetPaymentStatus200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    isOrderPayed: value['isOrderPayed'],
    nextStage: ApplicationStageToJSON(value['nextStage']),
    selectedProduct: value['selectedProduct'],
    offerDocumentUrl: value['offerDocumentUrl'],
  }
}
